import { render, staticRenderFns } from "./DatabaseTemplate.vue?vue&type=template&id=07923e5b&scoped=true&"
import script from "./DatabaseTemplate.vue?vue&type=script&lang=js&"
export * from "./DatabaseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseTemplate.vue?vue&type=style&index=0&id=07923e5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07923e5b",
  null
  
)

export default component.exports